import React, { ReactElement, useEffect } from "react";
import { Group, Modal, Stack, Text } from "@mantine/core";
import { Button } from "@jem-open/jem-ui";

export type ListItemButtonProps = {
  id: string;
  verify: {
    show: boolean | undefined;
    message?: string;
    button?: string;
    callback?: () => void;
  };
  callback: () => void;
  element: ReactElement;
  active: boolean;
};
export type ListItemButtonsProps = {
  elements: ListItemButtonProps[];
};
const ListItemButtons: React.FC<ListItemButtonsProps> = ({ elements }) => {
  const [verify, setVerify] = React.useState<ListItemButtonProps>();

  useEffect(() => {
    if (verify && verify.verify.show && verify.verify.callback) {
      verify.verify.callback();
    }
  }, [verify]);

  return (
    <>
      <Group
        spacing="sm"
        styles={{
          root: {
            flexFlow: "nowrap",
          },
        }}
      >
        {elements.map((cta) =>
          React.cloneElement(cta.element, {
            key: cta.id,
            disabled: cta?.element.props?.disabled || !cta.active,
            onClick: () => setVerify(cta),
          })
        )}
      </Group>
      <Modal
        opened={(verify && verify.verify.show) === true}
        onClose={() => setVerify(undefined)}
        title="Confirm"
      >
        <Stack>
          <Text align="center">{verify?.verify?.message}</Text>
          {verify && (
            <Button
              variant="primary"
              onClick={() => {
                setVerify(undefined);
                verify.callback();
              }}
            >
              {verify?.verify?.button}
            </Button>
          )}
        </Stack>
      </Modal>
    </>
  );
};
export default ListItemButtons;
